import React from 'react'
import * as d3 from "../d3.modified.js"
import {TemplatesLib} from '../TemplatesLib'
import {InlineTex} from 'react-tex'

export default class AcademicNode extends React.PureComponent {
    constructor(props) {
        super(props)
        this.props.nodeItem.refs = {}
        this.props.nodeItem.refs.fields = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleResize: this.styleResize,
            styleFade: this.styleFade,
            styleLinked: this.styleLinked,
            destyleLinked: this.destyleLinked,
            dom: this
        }
    }

    styleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: true,
        })
    }

    destyleLinked = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'linkedto',
            val: false,
        })
    }

    postModifiers = () => {
        var node = this.props.nodeItem
        this.position = undefined
        this.props.nodeItem.isJustClickNotDrag = false

        const _step = 10

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        this.styleResize()

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        if (this.props.edit) {
            node.refs.resizer.call(d3.drag()
                .on('start', ()=>{
                    node.resizeData = {
                        width: node.width,
                        height: node.height,
                        x: d3.event.x,
                        y: d3.event.y
                    }
                    this.props.clickHandler(node, false)
                })
                .on('drag', ()=>{
                    var newWidth = (d3.event.x-node.resizeData.x) + node.resizeData.width
                    let oldWidth = node.width
                    let oldHeight = node.height
                    if (newWidth>this.minWidth && newWidth<1200) {
                        if (this.props.keyPressDict.shift) {
                            node.width = Math.floor(newWidth/_step)*_step
                        } else {
                            node.width = newWidth
                        }
                    }
                    var newHeight = (d3.event.y-node.resizeData.y) + node.resizeData.height
                    if (newHeight>this.minHeight && newHeight<1200) {
                        if (this.props.keyPressDict.shift) {
                            node.height = Math.floor(newHeight/_step)*_step
                        } else {
                            node.height = newHeight
                        }
                    }
                    this.styleResize()

                    this.props.dragHandler((node.width-oldWidth)*0.5, (node.height-oldHeight)*0.5)
                    this.props.resizeHandler(node.width, node.height, node.id)
                })
                .on('end', ()=>{
                    //this.props.dragEndHandler()
                    this.props.resizeEndHandler()
                })
            )
            node.refs.holder.call(d3.drag()
                .on('start', ()=>{
                    this.position = {x:d3.event.x, y:d3.event.y}
                    this.props.hideCtxMenus()

                    // <grided>
                    this.startDragMPosX = d3.event.x
                    this.startDragMPosY = d3.event.y
                    this.startDragPosX = node.x
                    this.startDragPosY = node.y
                    // </grided>

                    this.props.dragStartHandler()
                })
                .on('drag', ()=>{
                    node.refs.holder.classed('moving', true)
                    if (node._selectionId === -1) {
                        this.props.clickHandler(node, true)
                    }
                    if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {

                        // <grided>
                        if (this.props.keyPressDict.shift) {
                            let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-node.width*0.5
                            let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-node.height*0.5
                            x = parseInt((x+_step/2)/_step)*_step
                            y = parseInt((y+_step/2)/_step)*_step

                            let dx = x-node.x+node.width*0.5
                            let dy = y-node.y+node.height*0.5
                            this.props.dragHandler(dx, dy)
                        } else {
                        // </grided>
                            this.props.dragHandler(d3.event.dx, d3.event.dy)
                        }
                    }
                })
                .on('end', ()=>{
                    node.refs.holder.classed('moving', false)
                    let newPosition = {x:d3.event.x, y:d3.event.y}
                    if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                        this.props.dragEndHandler()
                    }
                })
            )
        }

        node.refs.holder
            .on('mouseenter', ()=>{
                this.props.highlightConnections(node)
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                this.props.dehighlightConnections(node)
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })


        node.refs.holder
            .on("click", ()=>{
                    if (this.props.keyPressDict.link && this.props.edit) {
                        this.props.createLink(node)
                    } else {
                        this.props.clickHandler(node)
                    }
                    d3.event.stopPropagation()
            })
            .on("dblclick", ()=>{
                node.properties.url.forEach(url=>{
                    window.open((url.href.substr(0,4)==='http'?'':'//')+url.href, '_blank');
                })
                d3.event.stopPropagation()
            })
    }

    componentDidMount() {
        this.postModifiers();
    }

    componentDidUpdate() {
        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        var node = this.props.nodeItem
        this.props.enqueueStyleChange({
            elem: node.refs.background,
            prop: 'fill',
            val: node._compareType?diffColors[node._compareType]:node.properties.color
        })
        this.styleResize()

        // let shit = node.refs.content.node().getBoundingClientRect()
        // console.log(shit.width, shit.height)
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x-node.width/2} ${node.y-node.height/2})`
        })
    }

    styleResize = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}
        var _s = (a,b,c) => {this.props.enqueueStyleChange({elem:a,prop:b,val:c})}

        _(node.refs.shadow, 'width', node.width)
        _(node.refs.shadow, 'height', node.height)

        _(node.refs.background, 'width', node.width)
        _(node.refs.background, 'height', node.height)

        _(node.refs.fobj, 'width', node.width)
        _(node.refs.fobj, 'height', node.height-10)

        _(node.refs.resizer, 'x', node.width-10)
        _(node.refs.resizer, 'y', node.height-10)

        _(node.refs.holder, 'transform', `translate(${node.x-node.width/2} ${node.y-node.height/2})`)
    }

    // styleHover = () => {
    //     var node = this.props.nodeItem
    //     this.props.enqueueClassChange({
    //         elem: node.refs.holder,
    //         class: 'hovered',
    //         val: true,
    //     })
    // }

    styleSelect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.edge,
        //     class: 'active',
        //     val: true,
        // })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        // this.props.enqueueClassChange({
        //     elem: node.refs.edge,
        //     class: 'active',
        //     val: false,
        // })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        const hasImage = (node.properties.image!=='')
        const hasIndicators = (node.comments>0 || node.properties.url.length>0 || node.properties.files.length>0)

        if (hasImage) {
            this.minHeight = hasIndicators?110:80
            this.minWidth = 80
        } else {
            this.minHeight = 20
            this.minHeight += node.comments>0?20:0
            this.minHeight += node.properties.url.length>0?20:0
            this.minHeight += node.properties.files.length>0?20:0
            this.minWidth = 40
        }

        return (
            <g
                className="node-holder node-superref-holder"
                transform={`translate(${node.x-node.width/2} ${node.y-node.height/2})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* BACKGROUND + EDGE */}
                <rect
                    className="node-superref-shadow"
                    width={node.width}
                    height={node.height}
                    x="1.5"
                    y="1.5"
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.shadow=d3.select(c)}
                />
                <rect
                    className="node-superref-background"
                    id={`N_${node.id}_bg`}
                    width={node.width}
                    height={node.height}
                    rx="3"
                    ry="3"
                    ref={c=>node.refs.background=d3.select(c)}
                    style={{
                        fill: node._compareType
                            ? diffColors[node._compareType]
                            : node.properties.color,
                        stroke: node._compareType
                            ? '#E1E8ED'
                            : node.properties.bdcolor
                    }}
                />

                {/*<path d={`
                      M 3,0
                      h 2
                      v ${node.height}
                      h -2
                      a 3,3 0 0 1 -3,-3
                      v ${-node.height+6}
                      a 3,3 0 0 1 3,-3
                      z`}
                    className="node-academic-edge"
                    id={`N_${node.id}_edge`}
                    ref={c=>node.refs.edge=d3.select(c)}
                    style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                ></path>*/}

                <foreignObject key="content" x="0" y="0" width={node.width} height={node.height} ref={c=>node.refs.fobj=d3.select(c)} style={{pointerEvents: 'none', overflow: 'hidden'}}>
                    <div className="node-superref">
                        <div className="node-superref-sidebar" style={{
                            width: (hasImage?'70px':'30px'),
                            display: (hasImage||hasIndicators)?'':'none'
                        }}>
                        {
                            (node.properties.image!=='')
                                ? <div
                                    className="node-superref-cover"
                                    style={{
                                        backgroundImage: `url(${node.properties.image})`
                                    }}
                                    ref={c=>node.refs.cover=d3.select(c)}
                                ></div>
                                : null
                        }
                        {
                            <div>
                                {
                                    (node.properties.files.length>0)
                                        ? <span className={hasImage?'horizontal':''}>
                                            <svg width="20" height="16" viewBox="0 0 20 20">
                                                <path fill="#999" d="M9.5 20c-2.481 0-4.5-2.019-4.5-4.5v-12c0-1.93 1.57-3.5 3.5-3.5s3.5 1.57 3.5 3.5v11c0 1.378-1.122 2.5-2.5 2.5s-2.5-1.122-2.5-2.5v-6c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v6c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5v-11c0-1.378-1.122-2.5-2.5-2.5s-2.5 1.122-2.5 2.5v12c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v7c0 2.481-2.019 4.5-4.5 4.5z" />
                                            </svg> {/*node.properties.files.length*/}
                                        </span>
                                        : null
                                }
                                {
                                    (node.comments>0)
                                        ? <span className={hasImage?'horizontal':''}>
                                            <svg width="20" height="16" viewBox="0 0 20 20">
                                                <path fill="#999" d="M0.5 19c-0.225 0-0.422-0.15-0.482-0.367s0.032-0.447 0.225-0.562c1.691-1.014 2.392-2.489 2.641-3.179-1.838-1.407-2.884-3.354-2.884-5.392 0-1.029 0.258-2.026 0.768-2.964 0.486-0.894 1.18-1.695 2.061-2.381 1.787-1.39 4.156-2.156 6.671-2.156s4.884 0.766 6.671 2.156c0.881 0.685 1.575 1.486 2.061 2.381 0.51 0.937 0.768 1.934 0.768 2.964s-0.258 2.026-0.768 2.964c-0.486 0.894-1.18 1.695-2.061 2.381-1.787 1.39-4.156 2.156-6.671 2.156-1.033 0-2.047-0.129-3.016-0.385-0.429 0.286-1.231 0.793-2.189 1.27-1.488 0.74-2.764 1.115-3.794 1.115zM9.5 3c-4.687 0-8.5 2.916-8.5 6.5 0 1.815 1.005 3.562 2.756 4.792 0.172 0.121 0.25 0.336 0.196 0.539-0.117 0.436-0.515 1.633-1.58 2.788 1.302-0.456 2.704-1.247 3.739-1.959 0.123-0.085 0.277-0.11 0.421-0.069 0.948 0.271 1.947 0.409 2.968 0.409 4.687 0 8.5-2.916 8.5-6.5s-3.813-6.5-8.5-6.5z"/>
                                            </svg> {/*node.comments*/}
                                        </span>
                                        : null
                                }
                                {
                                    (node.properties.url.length>0)
                                        ? <span className={hasImage?'horizontal':''}>
                                            <svg width="20" height="16" viewBox="0 0 20 20">
                                                <path fill="#999" d="M10.682 12.998c-0.943 0-1.886-0.359-2.604-1.077-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0c1.046 1.046 2.747 1.046 3.793 0l3.636-3.636c1.046-1.046 1.046-2.747 0-3.793s-2.747-1.046-3.793 0l-3.068 3.068c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l3.068-3.068c1.436-1.436 3.772-1.436 5.207 0s1.436 3.772 0 5.207l-3.636 3.636c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                                <path fill="#999" d="M4.682 18.998c-0.943 0-1.886-0.359-2.604-1.077-1.436-1.436-1.436-3.772 0-5.207l3.636-3.636c1.436-1.436 3.772-1.436 5.207 0 0.195 0.195 0.195 0.512 0 0.707s-0.512 0.195-0.707 0c-1.046-1.046-2.747-1.046-3.793 0l-3.636 3.636c-1.046 1.046-1.046 2.747 0 3.793s2.747 1.046 3.793 0l3.068-3.068c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-3.068 3.068c-0.718 0.718-1.661 1.077-2.604 1.077z"></path>
                                            </svg> {/*node.properties.url.length*/}
                                        </span>
                                        : null
                                }
                            </div>
                        }
                        </div>

                        <div className="node-superref-content" ref={c=>node.refs.content=d3.select(c)}>
                            {
                                TemplatesLib[node.properties.templateId].fields.map(field=>{
                                    if (field.hasRender && node.properties._render[field.name].display) {
                                        const {display, ...rest} = node.properties._render[field.name]
                                        let val = Array.isArray(node.properties[field.name])
                                            ? node.properties[field.name].join(', ')
                                            : node.properties[field.name]
                                        val = (val==='')?'\u00A0':val


                                        let _overflow = (!rest.overflow)
                                            ? {
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            } : {
                                                whiteSpace: 'pre-wrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                            }
                                        let fStyle = {
                                            fontSize: rest.fontSize,
                                            fontStyle: rest.fontStyle,
                                            fontWeight: rest.fontWeight,
                                            color: rest.fill,
                                            lineHeight: Math.floor(parseInt(rest.fontSize)*1.4 - AcademicNode.fireFoxCorrection)+'px',
                                            textAlign: rest.textAlign,
                                            // backgroundColor: rest.backgroundColor,
                                            ..._overflow
                                        }
                                        return (
                                            <div
                                                key={field.name}
                                                className="node-superref-content-field"
                                                style={fStyle}
                                            >
                                                <InlineTex texContent={val}/>
                                            </div>
                                        )
                                    }
                                    return null
                                })
                            }
                        </div>
                    </div>
                </foreignObject>

            {/* RESIZE */}
                <rect
                    display={this.props.edit ? "default" : "none"}
                    x={node.width-10}
                    y={node.height-10}
                    width="10"
                    height="10"
                    className="node-superref-resizer"
                    ref={c=>node.refs.resizer=d3.select(c)}
                />
            </g>
        )
    }
}

AcademicNode.fireFoxCorrection = navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ? 1 : 0


// WEBPACK FOOTER //
// ./src/components/nodes/SuperRefNode.js